import React, { FunctionComponent, useMemo } from 'react';

import { JobSearch as JobSearchType } from '@gojob/cms';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import JobSearchRedirection from '../../JobSearchRedirection';

export interface JobSearchProps extends JobSearchType {
  className?: string;
}

export const JobSearchFragment = graphql`
  fragment JobSearchFragment on SanityJobSearch {
    inputLabel: input_label
    buttonLabel: button_label
    id: html_id
  }
`;

const JobSearch: FunctionComponent<JobSearchProps> = (props) => {
  const { inputLabel, buttonLabel, id, className } = props;

  const href = process.env.FOG_V2_URL || '/';

  return (
    <BreakpointContainer maxWidth="md" padding={{ xs: [6, 4], md: 8 }} className={className}>
      <JobSearchRedirection
        width="100%"
        buttonLabel={buttonLabel}
        buttonId={id}
        inputLabel={inputLabel}
        href={href}
      />
    </BreakpointContainer>
  );
};

export default JobSearch;
